import React from 'react';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from '@mui/material';
import { Icons } from '../icons';
import { useNavigate } from 'react-router-dom';

const { Menu: MenuIcon, Edit, Archive, Delete } = Icons;

interface Props {
  anchorEl: HTMLElement | null;
  open: boolean;
  onOpen(e: React.MouseEvent<HTMLElement>, idx: string): void;
  onClose(): void;
  rowIdx: string | null;
  idx: string;
  onDelete(idx: string): void;
  onArchive(idx: string): void;
  isEdit?: boolean;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const MoreMenu: React.FC<Props> = ({
  anchorEl,
  open,
  onOpen,
  onClose,
  rowIdx,
  idx,
  onDelete,
  onArchive,
  isEdit = true,
  setOpen,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <IconButton size='medium' sx={{ p: 0 }} onClick={(e) => onOpen(e, idx)}>
        <MenuIcon className='w-6 h-6 text-gray-500' />
      </IconButton>

      {rowIdx === idx && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={onClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            sx: {
              borderRadius: '16px',
              width: 296,
              '& .MuiMenuItem-root .MuiTypography-root': { fontSize: '18px' },
            },
          }}
        >
          {isEdit && (
            <MenuItem
              onClick={() => {
                navigate(`/publisher/edit-gamics/${idx}`);
                // onClose();
              }}
              sx={{ gap: 2, py: 2 }}
            >
              <ListItemIcon>
                <Edit className='w-6 h-6' />
              </ListItemIcon>
              <ListItemText primary='Request Edit' />
            </MenuItem>
          )}

          {setOpen && (
            <MenuItem
              onClick={() => {
                setOpen(true);
                onClose();
              }}
              sx={{ gap: 2, py: 2 }}
            >
              <ListItemIcon>
                <Edit className='w-6 h-6' />
              </ListItemIcon>
              <ListItemText primary='Campaign Insights' />
            </MenuItem>
          )}
          {/* <MenuItem
          onClick={() => {
            onClose();
            onArchive(idx);
          }}
          sx={{ gap: 2, py: 2 }}
        >
          <ListItemIcon>
            <Archive className='w-6 h-6' />
          </ListItemIcon>
          <ListItemText primary='Archive' />
        </MenuItem> */}
          <MenuItem
            onClick={() => {
              onClose(); // close the menu
              onDelete(idx); // open the dialog
            }}
            sx={{ gap: 2, py: 2 }}
          >
            <ListItemIcon>
              <Delete className='w-6 h-6' />
            </ListItemIcon>
            <ListItemText className='text-button' primary='Delete Gamic' />
          </MenuItem>
        </Menu>
      )}
    </>
  );
};

export default MoreMenu;
